module.exports = __webpack_public_path__ + "img/multiplication.72ba5f8f.svg";